export enum NavigationItemsEnum {
    Performance,
    Learners,
    Faculty,
    Groups,
    Subscriptions,
    Quizzes,
    Curriculum,
    Assessments,
    Report,
    Questions,
    ContentLibrary,
    AiTools,
    AiPerformanceInsights,
    Collapse
}
